<template>
<div class="animated fadeIn">
  <div class="row">
    <div class="col-sm-9">
      <div class="row m-0">
        <div class="col-sm-12 m-auto">
          <button type="button" class="btn btn-primary" @click="showStoreDateExceptionModal()">
            <!-- icon icon="plus"></icon --> {{$t('ADDEXCEPTION')}}
          </button>
        </div>
      </div>
      <div class="card-body">
        <div class="row mb-2">
          <div class="col-sm-12">
            <table class="table table-foursight table-striped table-hover table-sm">
              <thead>
                <tr>
                  <th>{{$t('DATE')}}</th>
                  <th>{{$t('OPERATINHOURS')}}</th>
                  <th>{{$t('ACTION')}}</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="item in storeDateException.root">
                  <tr aria-rowindex="1" class=" table-ellipsis">
                    <td>{{moment.utc(item.date).local().format('YYYY-MM-DD')}}</td>
                    <td>{{ moment(moment.utc(item.startTime).toDate()).local().format('hh:mm A')}} to {{moment(moment.utc(item.closeTime).toDate()).local().format('hh:mm A')}}</td>
                    <td>
                      <button type="button" class="btn btn-secondary btn-sm mr-2" @click="showStoreDateExceptionModal(item)">{{$t('EDIT')}}</button>
                      <button type="button" class="btn btn-delete btn-sm" @click="deleteRow(item.storeDateExceptionId)">{{$t('DELETE')}}</button>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-3">
      <aside class="smaller smaller-store">
        <div class="dash-field-dark">
          <h3>{{$t('STOREPROFILE')}}</h3>
        </div>
        <div class="dash-field-smaller">

          <div class="polje-dash polje-dash-user">
            <div class="tekst-dash mb-sm">
              <h4>{{store.name}}</h4>
              <p><small>{{store.address}}<br>
                  {{store.city}}, {{store.province}}, {{store.postalCode}}<br>
                  P: {{store.phoneNumber}}<br><br>

                  <b>{{$t('MANAGER')}}</b><br>
                  {{store.managerName}} <br><br>

                  <b>{{$t('REGIONALMANAGER')}}</b><br>
                  {{store.regionName}} <br>

                  <b>{{$t('DEFAULTOPERATINGHOURS')}}</b><br>
                  <template v-for="item in store.workingTimeOut">
                    {{item.text}} {{item.open}} to {{item.close}}<br>
                  </template></small></p>
            </div>
            <div class="adjust">
              <button type="button" class="btn btn-secondary btn-sm mr-2 mt-4" @click="showModal(store)">{{$t('EDIT')}}</button>
            </div>
          </div>
        </div>
      </aside>
    </div>
  </div>
  <b-modal ref="formmodal" :title="$t('STOREFORM')" ok-title="submit" hide-footer size="xl" no-close-on-backdrop>
    <div class="d-block">
      <storeform v-bind:formData="formData" v-bind:formError="formError" v-bind:province="province" v-bind:users="users"></storeform>
    </div>
    <div class="text-right">
      <b-btn class="mt-3" variant="secondary mr-lg" @click="hideModal">{{$t('CANCEL')}}</b-btn>
      <b-btn class="mt-3" variant="primary" @click="submitData(formData)">{{$t('SAVE')}}</b-btn>
    </div>
  </b-modal>
  <b-modal ref="formmodalsec" :title="$t('DATEEXCEPTIONSFORM')" ok-title="submit" hide-footer size="sm" no-close-on-backdrop>
    <div class="d-block">
      <dateexceptionsform v-bind:formData="formDataSec" v-bind:formError="formError"></dateexceptionsform>
    </div>
    <div class="text-right">
      <b-btn class="mt-3" variant="secondary-trans mr-4" @click="hideStoreDateExceptionModal">{{$t('CANCEL')}}</b-btn>
      <b-btn class="mt-3" variant="primary" @click="submitDataDateException(formDataSec)">{{$t('SAVE')}}</b-btn>
    </div>
  </b-modal>
</div>
</template>

<script>
import
{
  mapActions,
  mapGetters
}
from 'vuex'
import moment from 'moment';

import StoreDateExceptionApi from '@/api/salesportal/StoreDateException'
import StoreApi from '@/api/salesportal/Store'
import ProvinceApi from '@/api/salesportal/Province'
import UsersApi from '@/api/admin/Users'
import StoreForm from '../../Form'
import DateExceptionsForm from './DateExceptionsForm'

export default
{
  name: 'DateExceptionsWin',
  props: ['storeId', 'tabIndex'],
  components:
  {
    storeform: StoreForm,
    dateexceptionsform: DateExceptionsForm
  },
  data: function()
  {
    return {
      storeDateException:
      {},
      formDataSec:
      {
        storeId: null,
        date: '',
        startTimeOut: '',
        closeTimeOut: ''
      },
      store:
      {},
      province:
      {},
      users:
      {},
      formError:
      {},
      formData:
      {
        'provinceId': null,
        'storeManagerId': null,
        'regionalManagerId': null,
        'code': '',
        'name': '',
        'address': '',
        'city': '',
        'postalCode': '',
        'phoneNumber': '',
        'workingTimeOut': [
        {
          text: 'SUNDAY',
          open: '',
          close: ''
        },
        {
          text: 'MONDAY',
          open: '',
          close: ''
        },
        {
          text: 'TUESDAY',
          open: '',
          close: ''
        },
        {
          text: 'WEDNESDAY',
          open: '',
          close: ''
        },
        {
          text: 'THURSDAY',
          open: '',
          close: ''
        },
        {
          text: 'FRIDAY',
          open: '',
          close: ''
        },
        {
          text: 'SATURDAY',
          open: '',
          close: ''
        }]
      }
    }
  },
  created()
  {
    var me = this;
    //me.getStoreDateException();
    //me.getStore();
    //me.getProvince();
    //me.getUsers();
  },
  methods:
  {
    async getStoreDateException()
    {
      var me = this;
      try
      {
        var data = await StoreDateExceptionApi.selectRow(
        {
          storeId: me.storeId
        });

        if (data.error && data.error == true)
        {
          me.$notify.notice(data);
          me.loading = false;
          return;
        }

        me.storeDateException = data;
      }
      catch (e)
      {
        me.$notify.notice(e);
      }
    },
    async deleteRow(id)
    {
      var me = this;
      try
      {
        me.$store.commit('setModalAlert',
        {
          text: me.$i18n.t('AREYOUSHURE'),
          btnAction: async function()
          {
            var data = await StoreDateExceptionApi.deleteRow(
            {
              id: id
            });
            me.$notify.notice(data);
            await me.getStoreDateException();
          }
        })
      }
      catch (e)
      {
        me.$notify.notice(e);
      }
    },
    showStoreDateExceptionModal(item)
    {
      var me = this;
      if (typeof item != 'undefined')
      {
        me.$set(item, 'startTimeOut', moment.utc(item.startTime).local().format('YYYY-MM-DD HH:mm:ss'));
        me.$set(item, 'closeTimeOut', moment.utc(item.closeTime).local().format('YYYY-MM-DD HH:mm:ss'));
        me.formDataSec = item;
      }
      me.formDataSec.storeId = me.storeId;
      this.$refs.formmodalsec.show()
    },
    async submitDataDateException(item)
    {
      var me = this;
      try
      {
        if (typeof item.storeDateExceptionId != 'undefined')
        {
          item.id = item.storeDateExceptionId;
          delete(item.storeDateExceptionId);
        }

        item.date = moment(item.date).format('YYYY-MM-DD');
        const tmpStart = moment(item.startTimeOut).format('HH:mm:ss');
        const tmpEnd = moment(item.closeTimeOut).format('HH:mm:ss');
        
        item.startTime = moment(`${item.date} ${tmpStart}`).utc().format('YYYY-MM-DD HH:mm:ss');
        item.closeTime = moment(`${item.date} ${tmpEnd}`).utc().format('YYYY-MM-DD HH:mm:ss');


        var data = await StoreDateExceptionApi.submitData(item);
        if (data.error)
        {
          me.$notify.notice(data);
          me.formError = data;
        }
        else
        {
          me.$notify.notice(data);
          me.hideStoreDateExceptionModal();
          await me.getStoreDateException();
        }
      }
      catch (e)
      {
        me.$notify.notice(e);
      }
    },
    hideStoreDateExceptionModal()
    {
      var me = this;
      this.$refs.formmodalsec.hide();

      me.formDataSec = {
        storeId: null,
        date: '',
        startTime: '',
        closeTime: ''
      }
    },
    async getStore()
    {
      var me = this;
      try
      {
        var data = await StoreApi.selectRow(
        {
          storeId: me.storeId
        });
        if (data.error && data.error == true)
        {
          me.$notify.notice(data);
          me.loading = false;
          return;
        }

        me.store = data.root[0];
      }
      catch (e)
      {
        me.$notify.notice(e);
      }
    },
    async getProvince()
    {
      var me = this;
      try
      {
        var data = await ProvinceApi.selectRow();
        if (data.error && data.error == true)
        {
          me.$notify.notice(data);
          me.loading = false;
          return;
        }

        me.province = data;
      }
      catch (e)
      {
        me.$notify.notice(e);
      }
    },
    getUsers()
    {
      var me = this;
      try
      {
        UsersApi.selectActiveUsers(me.getParams, function(data)
        {
          if (data.error && data.error == true)
          {
            me.$notify.notice(data);
            return;
          }

          for (var i = 0; i < data.root.length; i++)
          {
            data.root[i].password = '';
            data.root[i].trhidden = false;
          }

          me.users = data;
        });
      }
      catch (e)
      {
        me.$notify.notice(e);
      }
    },
    showModal(item)
    {
      var me = this;
      if (typeof item != 'undefined') me.formData = item;
      this.$refs.formmodal.show()
    },
    async submitData(item)
    {
      var me = this;
      try
      {
        if (typeof item.storeId != 'undefined')
        {
          item.id = item.storeId;
          delete(item.storeId);
        }

        var data = await StoreApi.submitData(item);
        if (data.error)
        {
          me.$notify.notice(data);
          me.formError = data;
        }
        else
        {
          me.$notify.notice(data);
          me.hideModal();
          await me.getStore();
        }
      }
      catch (e)
      {
        me.$notify.notice(e);
      }
    },
    hideModal()
    {
      var me = this;
      this.$refs.formmodal.hide();

      me.formData = {
        'provinceId': null,
        'storeManagerId': null,
        'regionalManagerId': null,
        'code': '',
        'name': '',
        'address': '',
        'city': '',
        'postalCode': '',
        'phoneNumber': '',
        'workingTimeOut': [
        {
          text: 'SUNDAY',
          open: '',
          close: ''
        },
        {
          text: 'MONDAY',
          open: '',
          close: ''
        },
        {
          text: 'TUESDAY',
          open: '',
          close: ''
        },
        {
          text: 'WEDNESDAY',
          open: '',
          close: ''
        },
        {
          text: 'THURSDAY',
          open: '',
          close: ''
        },
        {
          text: 'FRIDAY',
          open: '',
          close: ''
        },
        {
          text: 'SATURDAY',
          open: '',
          close: ''
        }]
      }
    }
  },
  watch:
  {
    async tabIndex(val)
    {
      var me = this;
      try
      {
        if (val == 4)
        {
          await me.getStoreDateException();
          await me.getStore();
          await me.getProvince();
          await me.getUsers();
        }
      }
      catch (error)
      {
        me.$notify.notice(e);
      }
    }
  },
  computed:
  {

  }
}
</script>
